import { render } from "./IncomeProtectionAnalysis.vue?vue&type=template&id=bf28ff02&scoped=true"
import script from "./IncomeProtectionAnalysis.vue?vue&type=script&lang=js"
export * from "./IncomeProtectionAnalysis.vue?vue&type=script&lang=js"

import "./IncomeProtectionAnalysis.vue?vue&type=style&index=0&id=bf28ff02&lang=css"
import "./IncomeProtectionAnalysis.vue?vue&type=style&index=1&id=bf28ff02&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf28ff02"]])

export default __exports__